"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Salesforce = void 0;

var Salesforce =
/** @class */
function () {
  function Salesforce() {}

  Salesforce.prototype.CampaignMemberExportType = function () {
    return [{
      slug: 'duplicate',
      name: 'Duplicate',
      description: null,
      isSkipped: false,
      isCreated: false,
      isUpdated: false,
      isFailedCreating: false,
      isFailedUpdating: false,
      isDuplicate: true,
      isFailedUpdatingConvertedLead: false
    }, {
      slug: 'skipped',
      name: 'Skipped',
      description: null,
      isSkipped: true,
      isCreated: false,
      isUpdated: false,
      isFailedCreating: false,
      isFailedUpdating: false,
      isDuplicate: false,
      isFailedUpdatingConvertedLead: false
    }, {
      slug: 'created',
      name: 'Created',
      description: null,
      isSkipped: false,
      isCreated: true,
      isUpdated: false,
      isFailedCreating: false,
      isFailedUpdating: false,
      isDuplicate: false,
      isFailedUpdatingConvertedLead: false
    }, {
      slug: 'updated',
      name: 'Updated',
      description: null,
      isSkipped: false,
      isCreated: false,
      isUpdated: true,
      isFailedCreating: false,
      isFailedUpdating: false,
      isDuplicate: false,
      isFailedUpdatingConvertedLead: false
    }, {
      slug: 'failed-creating',
      name: 'Failed Creating',
      description: null,
      isSkipped: false,
      isCreated: false,
      isUpdated: false,
      isFailedCreating: true,
      isFailedUpdating: false,
      isDuplicate: false,
      isFailedUpdatingConvertedLead: false
    }, {
      slug: 'failed-updating',
      name: 'Failed Updating',
      description: null,
      isSkipped: false,
      isCreated: false,
      isUpdated: false,
      isFailedCreating: false,
      isFailedUpdating: true,
      isDuplicate: false,
      isFailedUpdatingConvertedLead: false
    }, {
      slug: 'failed-updating-converted-lead',
      name: 'Failed Updating Converted Lead',
      description: null,
      isSkipped: false,
      isCreated: false,
      isUpdated: false,
      isFailedCreating: false,
      isFailedUpdating: false,
      isDuplicate: false,
      isFailedUpdatingConvertedLead: true
    }];
  };

  Salesforce.prototype.CampaignMemberImportType = function () {
    return [{
      slug: 'new-member',
      name: 'New Member',
      description: null,
      isNewMember: true,
      isUpdatedMember: false,
      isSkippedMemberAsRemoved: false,
      isDuplicateInvitation: false,
      isDuplicateEmail: false
    }, {
      slug: 'updated-member',
      name: 'Updated Member',
      description: null,
      isNewMember: false,
      isUpdatedMember: true,
      isSkippedMemberAsRemoved: false,
      isDuplicateInvitation: false,
      isDuplicateEmail: false
    }, {
      slug: 'skipped-member-as-removed',
      name: 'Skipped Member As Removed',
      description: null,
      isNewMember: false,
      isUpdatedMember: false,
      isSkippedMemberAsRemoved: true,
      isDuplicateInvitation: false,
      isDuplicateEmail: false
    }, {
      slug: 'duplicate-invitation',
      name: 'Duplicate Invitation',
      description: null,
      isNewMember: false,
      isUpdatedMember: false,
      isSkippedMemberAsRemoved: false,
      isDuplicateInvitation: true,
      isDuplicateEmail: false
    }, {
      slug: 'duplicate-email',
      name: 'Duplicate Email',
      description: null,
      isNewMember: false,
      isUpdatedMember: false,
      isSkippedMemberAsRemoved: false,
      isDuplicateInvitation: false,
      isDuplicateEmail: true
    }];
  };

  Salesforce.prototype.CampaignMemberType = function () {
    return [{
      slug: 'contact',
      name: 'Contact',
      description: null,
      isContact: true,
      isLead: false
    }, {
      slug: 'lead',
      name: 'Lead',
      description: null,
      isContact: false,
      isLead: true
    }];
  };

  Salesforce.prototype.NewContactRuleType = function () {
    return [{
      slug: 'do-nothing',
      name: 'Do Nothing',
      description: 'Do nothing. They will remain only in Event Farm.',
      isDoNothing: true,
      isCreateContact: false,
      isCreateLead: false
    }, {
      slug: 'create-contact',
      name: 'Create Contact',
      description: 'Create a new Contact in Salesforce.',
      isDoNothing: false,
      isCreateContact: true,
      isCreateLead: false
    }, {
      slug: 'create-lead',
      name: 'Create Lead',
      description: 'Create a new Lead in Salesforce.',
      isDoNothing: false,
      isCreateContact: false,
      isCreateLead: true
    }];
  };

  return Salesforce;
}();

exports.Salesforce = Salesforce;